import { Expose, Transform, Type } from "class-transformer";
import DynamicWeightPriceRange from "./dynamicWeightPriceRange";
import Position from "./portfolioPosition";

export default class DynamicWeight {

  @Type(() => DynamicWeightPriceRange)
  @Expose() weightPriceRanges: DynamicWeightPriceRange[];

  @Transform(({ value }) => value && value.toISOString(), { toPlainOnly: true })
  @Transform(({ value }) => value && new Date(value), { toClassOnly: true })
  updatedAt: Date;

  /**
   * 
   * @param positionId The id of the position to which this dynamic weight belongs to.
   * @param updatedAt The last time this object was modified.
   * @param weightPriceRanges The array of price ranges used to determine the weight.
   */
  constructor(
    public positionId: string | undefined,
    updatedAt: Date,
    weightPriceRanges: DynamicWeightPriceRange[]
  ) {
    this.weightPriceRanges = weightPriceRanges;
    this.updatedAt = updatedAt;
  }

  /** Return the current weight of the position, dynamically determined by its current price. If the price couldn't fit into any range, return 0 as the weight. */
  weight(position: Position): number {
    const currentPrice = position.price;
    this.weightPriceRanges.sort((a, b) => a.priceMax < b.priceMax ? -1 : 1);
    const currentRange = this.weightPriceRanges.find(range => currentPrice <= range.priceMax);
    if (currentRange !== undefined) {
      return currentRange.weight;
    } else {
      return 0;
    }
  }
}